import { render, staticRenderFns } from "./PriceListButton.vue?vue&type=template&id=1bd40203&scoped=true"
import script from "./PriceListButton.vue?vue&type=script&lang=js"
export * from "./PriceListButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd40203",
  null
  
)

export default component.exports